export const VILLA_LOCATION = {
  name: "Ithaca Garden Villa",
  address: "Kioni, Ithaca — Ionian Sea, Greece",
  lat: 38.4478647,
  lng: 20.6895246,
  directions_url: "https://maps.app.goo.gl/nD6p9jA3wSg3LUkWA",
};

export default function Map({ height = 480, className = "", showLabel = true }) {
  const q = encodeURIComponent(`${VILLA_LOCATION.name}, Kioni`);
  const embedUrl = `https://maps.google.com/maps?q=${q}&ll=${VILLA_LOCATION.lat},${VILLA_LOCATION.lng}&z=15&output=embed`;
  return (
    <div className={`relative w-full overflow-hidden ${className}`} style={{ height }} data-testid="villa-map">
      <iframe
        title="Ithaca Garden Villa — Kioni, Ithaca"
        src={embedUrl}
        width="100%"
        height="100%"
        style={{ border: 0, filter: "grayscale(0.15) contrast(0.95)" }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
      {showLabel && (
        <a
          href={VILLA_LOCATION.directions_url}
          target="_blank"
          rel="noreferrer noopener"
          data-testid="map-directions-link"
          className="absolute bottom-6 left-6 bg-cream/95 backdrop-blur-sm border border-soft_border px-5 py-3 group hover:bg-ink hover:text-cream transition-colors"
        >
          <div className="overline mb-1">Directions</div>
          <div className="text-sm font-medium tracking-tight flex items-center gap-2">
            Open in Google Maps
            <span aria-hidden className="transition-transform group-hover:translate-x-1">→</span>
          </div>
        </a>
      )}
    </div>
  );
}
